<template>
  <div class="sheet">
    <!-- DRAG BAR -->
    <div class="drag-bar"></div>

    <div class="container-fluid h-100 p-0">
      <div class="row h-100 g-0">

        <!-- IMAGE AREA -->
        <div class="col-12 col-md-5 image-area">

          <!-- MAIN IMAGE -->
          <div class="main-img">
            <img :src="currentImage" />
          </div>

          <!-- THUMBNAILS -->
          <div class="thumb-list">
            <div v-for="(img, i) in images" :key="i" class="thumb" :class="{ active: img === currentImage }"
              @click="currentImage = img">
              <img :src="img" />
            </div>
          </div>

        </div>
        <!-- SALE -->
        <div class="col-12 col-md-3 info-area">

          <!-- SALE THUÊ -->
          <div class="sale-title mt-4">📦 Phí thuê hàng tháng (gồm VAT)</div>
          <span><i> *( Phương thức thuê thiết bị chỉ áp dụng tại xã/phường thí điểm của Vimass )</i> </span>
          <div class="sale-list">
            <div v-for="s in saleList" :key="'rent-' + s" class="sale-item" :class="{
              active: selectedRentSale === s,
              disabled: selectedBuySale !== null
            }" @click="toggleRentSale(s)">

              <img class="sale-img w-100" :src="firstImage" />
              <div class="sale-title-text text-center"> Phí chiết khấu {{ s }}%</div>
              <div class="sale-sub-text text-center">{{ saleRules[s].text }}</div>
            </div>
          </div>

          <!-- SALE MUA -->
          <div class="sale-title mt-4">🛒 Giá bán và giá chiết khấu (gồm VAT)</div>
          <div class="sale-list">
            <div v-for="s in saleList" :key="'buy-' + s" class="sale-item" :class="{
              active: selectedBuySale === s,
              disabled: selectedRentSale !== null
            }" @click="toggleBuySale(s)">

              <img class="sale-img w-100" :src="firstImage" />
              <div class="sale-title-text text-center">Chiết khấu {{ s }}%</div>
              <div class="sale-sub-text text-center">{{ saleRules[s].text }}</div>
            </div>
          </div>



          <div class="qty-box">
            <div class="qty-title">📦 Số lượng</div>

            <div class="qty-control">
              <button class="qty-btn" @click="decreaseQty">−</button>

              <input type="number" min="1" v-model.number="quantity" @input="onQtyChange" />

              <button class="qty-btn" @click="increaseQty">+</button>
            </div>
          </div>
          <div v-if="selectedSale && baseSellPrice > 0" class="final-price">
            <span class="old">
              {{ formatPrice(baseSellPrice) }}₫
            </span>
            <span class="new">
              {{ formatPrice(finalSellPrice) }}₫
            </span>
          </div>

        </div>

        <!-- INFO AREA -->
        <div class="col-12 col-md-4 info-area">
          <div class="sheet-content">
            <h6 class="product-name">
              {{ product.name }}
            </h6>

            <div class="price">

              <!-- CẢ 2 GIÁ -->
              <template v-if="baseSellPrice > 0 && baseRentPrice > 0">
                <div><span style="color: rgb(7, 149, 217);"> 📦 Giá thuê: <b>{{
                  formatPrice(rentPrice) }}₫</b></span> -💰 Giá bán: <b>{{ formatPrice(buyPrice) }}₫</b> </div>

              </template>

              <!-- CHỈ GIÁ BÁN -->
              <template v-else-if="baseSellPrice > 0">
                💰 Giá bán: <b>{{ formatPrice(baseSellPrice) }}₫</b>
              </template>

              <!-- CHỈ GIÁ THUÊ -->
              <template v-else-if="baseRentPrice > 0">
                📦 Giá thuê: <b>{{ formatPrice(baseRentPrice) }}₫</b>
              </template>

              <!-- LIÊN HỆ -->
              <template v-else>
                Liên hệ
              </template>

            </div>

            <p class="desc mt-3">
              {{ product.description }}
            </p>

            <p class="desc mt-5">
              {{ product.huongdan }}
            </p>
            <div style="font-size: 13px; font-weight: 600;" class="mt-3">- Tiền đặt cọc thuê thiết bị bằng 1 tháng tiền
              thuê; không
              được phép cho thuê lại; gia hạn hoặc trả thiết bị cần báo trước 1 tháng; thiết bị trả lại phải hoạt động
              bình thường;
              hư hỏng, mất mát phải bồi thường theo giá trị thực tế. <br>
              - Hết thời hạn thuê, khách hàng có thể mua thiết bị theo giá trị còn lại được Vimass công bố từng thời kỳ;
              tiền cọc
              được hoàn trả hoặc khấu trừ vào giá mua thiết bị.
            </div>
          </div>
          <!-- BUY BUTTON -->
          <div class="buy-bar d-flex gap-2" style="margin-bottom: 20px;">
            <!-- NÚT THUÊ -->
            <button class="btn btn-outline-danger w-50" style="    background: rgb(7 149 217);  color: white;"
              :disabled="rentPrice <= 0" @click="onRent">
              {{ rentPrice > 0 ? formatPrice(rentPrice) + '₫' : 'Liên hệ' }} 📦 Thuê ngay
            </button>
            <!-- NÚT MUA -->
            <button class="btn btn-danger w-50" :disabled="buyPrice <= 0" @click="onBuy">
              {{ buyPrice > 0 ? formatPrice(buyPrice) + '₫' : 'Liên hệ' }} 🛒 Mua ngay
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  data() {
    return {
      currentImage: "",
      selectedSale: null,
      selectedBuySale: null,   // sale cho MUA
      selectedRentSale: null, // sale cho THUÊ
      quantity: 1
    };
  },

  computed: {
    // ===== IMAGE =====
    images() {
      if (!this.product?.image) return [];
      return this.product.image.split(";").filter(Boolean);
    },

    firstImage() {
      return this.images[0] || "";
    },

    // ===== SALE =====
    saleList() {
      if (!this.product?.sale) return [];
      return this.product.sale
        .split(";")
        .map(s => Number(s))
        .filter(n => !isNaN(n));
    },

    saleRules() {
      return {
        5: { min: 5, max: 20, text: "5 – 20 cái" },
        10: { min: 21, max: 50, text: "21 – 50 cái" },
        15: { min: 51, max: Infinity, text: "Trên 50 cái" }
      };
    },

    // ===== GIÁ GỐC =====
    baseSellPrice() {
      return Number(this.product?.price) || 0;
    },

    baseRentPrice() {
      return Number(this.product?.giaThue) || 0;
    },

    // ===== GIÁ SAU SALE (CHỈ BÁN) =====
    finalSellPrice() {
      if (!this.selectedBuySale) return this.baseSellPrice;

      const price =
        this.baseSellPrice * (100 - this.selectedBuySale) / 100;

      return this.roundPrice(price);
    },
    finalRentPrice() {
      // chưa chọn sale → giá thuê gốc
      if (!this.selectedRentSale) {
        return this.baseRentPrice;
      }

      // lấy giá thuê sale theo %
      const salePrice =
        this.product?.giaThueSale?.[this.selectedRentSale];

      // nếu có giá sale thì dùng, không có thì fallback giá gốc
      return salePrice ? salePrice : this.baseRentPrice;
    }
    ,


    // ===== TỔNG =====
    totalSellPrice() {
      return this.finalSellPrice * this.quantity;
    },

    totalRentPrice() {
      return this.baseRentPrice * this.quantity;
    },

    // ===== GIÁ HIỂN THỊ =====
    displayPrice() {
      if (this.baseSellPrice > 0) return this.totalSellPrice;
      if (this.baseRentPrice > 0) return this.totalRentPrice;
      return 0;
    },
    // ===== GIÁ MUA =====
    buyPrice() {
      return this.roundPrice(this.finalSellPrice * this.quantity);
    },

    rentPrice() {
      return this.roundPrice(this.finalRentPrice * this.quantity);
    }
  },

  watch: {
    images: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          this.currentImage = val[0];
        }
      }
    }
  },

  methods: {
    toggleRentSale(s) {
      // nếu đang chọn mua → không cho chọn thuê
      if (this.selectedBuySale !== null) return;

      if (this.selectedRentSale === s) {
        this.selectedRentSale = null;
      } else {
        this.selectedRentSale = s;
        //  this.quantity = s;
      }
    },


    // ===== TOGGLE SALE MUA =====
    toggleBuySale(s) {
      // nếu đang chọn thuê → không cho chọn mua
      if (this.selectedRentSale !== null) return;

      if (this.selectedBuySale === s) {
        // click lần 2 → bỏ chọn
        this.selectedBuySale = null;
      } else {
        this.selectedBuySale = s;
        //this.quantity = s; // 5% → 5, 15% → 15
      }
    },

    roundPrice(value) {
      return Math.round(value);
    },
    formatPrice(v) {
      if (!v) return "0";
      return Number(v).toLocaleString("vi-VN");
    },

    increaseQty() {
      this.quantity++;
      this.autoSelectSale();
    },

    decreaseQty() {
      if (this.quantity > 1) {
        this.quantity--;
        this.autoSelectSale();
      }
    },

    onQtyChange() {
      if (this.quantity < 1) this.quantity = 1;
      this.autoSelectSale();
    },

    autoSelectSale() {
      let matchedSale = null;

      this.saleList.forEach(s => {
        const rule = this.saleRules[s];
        if (!rule) return;

        if (this.quantity >= rule.min && this.quantity <= rule.max) {
          matchedSale = s;
        }
      });

      this.selectedSale = matchedSale;
    },
    onBuy() {
      if (this.buyPrice <= 0) return;

      this.$emit("buy", {
        type: "buy",
        product: this.product,
        quantity: this.quantity,
        unitPrice: this.finalSellPrice,
        totalPrice: this.buyPrice,
        sale: this.selectedSale
      });
    },

    // ===== THUÊ =====
    onRent() {
      if (this.rentPrice <= 0) return;

      this.$emit("rent", {
        type: "rent",
        product: this.product,
        quantity: this.quantity,
        unitPrice: this.baseRentPrice,
        totalPrice: this.rentPrice
      });
    }
  }
};

</script>

<style scoped>
/* QUANTITY */
.qty-box {
  margin-top: 14px;
}

.qty-title {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
}

.qty-control {
  display: flex;
  align-items: center;
  gap: 6px;
}

.qty-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 18px;
  cursor: pointer;
  border-radius: 6px;
}

.qty-control input {
  width: 60px;
  height: 32px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

/* =========================
   BOTTOM SHEET
========================= */
.sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70vh;
  overflow: auto;
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, .15);
  animation: slideUp .25s ease;
  z-index: 9999;
}

/* DRAG BAR */
.drag-bar {
  width: 40px;
  height: 4px;
  background: #ccc;
  border-radius: 2px;
  margin: 8px auto;
}

/* =========================
   IMAGE AREA
========================= */
.image-area {
  background: #fff;
}

.main-img {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sale-box {
  margin-top: 12px;
}

.sale-title {
  font-size: 15px;
  font-weight: 600;

  margin-bottom: 6px;
}

.sale-list {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.sale-item {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}

.sale-item.active {
  border-color: #ee4d2d;
  color: #ee4d2d;
  font-weight: 600;
}

.sale-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 4px;
  background: #fff;
}

/* FINAL PRICE */
.final-price {
  margin-top: 8px;
}

.final-price .old {
  text-decoration: line-through;
  color: #999;
  font-size: 13px;
  margin-right: 8px;
}

.final-price .new {
  color: #ee4d2d;
  font-size: 18px;
  font-weight: bold;
}

.main-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
}

/* THUMBNAILS */
.thumb-list {
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  overflow-x: auto;
  justify-content: center;
}

.thumb {
  width: 68px;
  height: 68px;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
}

.thumb.active {
  border-color: #ee4d2d;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 6px;
}

/* =========================
   INFO AREA
========================= */
.info-area {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sheet-content {
  padding: 12px;
  overflow-y: auto;
  flex: 1;
}

.product-name {
  font-size: 17px;
  font-weight: 600;
}

.price {
  color: #ee4d2d;
  font-size: 18px;
  font-weight: bold;
  margin-top: 4px;
}

.desc {
  font-size: 13px;
  color: #555;
  white-space: pre-line;
  margin-top: 8px;
}

/* BUY BAR */
.buy-bar {
  padding: 10px;
  border-top: 1px solid #eee;
  background: #fff;
}

/* =========================
   DESKTOP
========================= */
@media (min-width: 768px) {
  .sheet {
    height: 70vh;
  }

  .main-img {
    height: 450px;
  }
}

/* =========================
   ANIMATION
========================= */
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}
</style>
